// Images
import CarouselCard from '/public/images/album/carousel-card.png';
import OverlayCard from '/public/images/album/overlay-card.png';

export const ALBUM_TYPE_MANUAL = 'manual';
export const ALBUM_TYPE_AUTOMATIC = 'auto';

export const albumTypes = [
    {
        title: 'content:modal.create_modal.action.manual',
        description: 'content:modal.create_modal.action.manual_text',
        type: ALBUM_TYPE_MANUAL,
        image: CarouselCard
    },
    {
        title: 'content:modal.create_modal.action.automatic',
        description: 'content:modal.create_modal.action.automatic_text',
        type: ALBUM_TYPE_AUTOMATIC,
        image: OverlayCard
    }
] as const;
